exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.map-wrapper{width:100%}.map-wrapper .map-img{position:relative;width:100%}.map-wrapper .geo-tags-wrapper{position:relative;width:100%;margin-bottom:50px}.map-wrapper .geo-tags-wrapper .geo-tags-header{text-align:center;font-family:brandon-light;font-size:30px;color:#4a4a4a;letter-spacing:1.29px;margin-top:20px;margin-bottom:30px}.map-wrapper .geo-tags-wrapper .tag-text-city{text-align:left;font-family:Open Sans,sans-serif;font-weight:700;font-size:20px;color:#4a4a4a;letter-spacing:.86px;line-height:25.31px}.map-wrapper .geo-tags-wrapper .tag-text-city .tag-text-name{font-family:Open Sans,sans-serif;font-weight:400;font-style:italic}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Map_old/Map_old.scss
// module id = 1580
// module chunks = 0